import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["audience"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isShowEverywhere } from 'AudienceTargetingUIComponents/utils/audience';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const TargetedWebsitesDescription = _ref => {
  let {
      audience
    } = _ref,
    textProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isAllPages = isShowEverywhere(audience);
  return /*#__PURE__*/_jsx(Text, Object.assign({
    "data-test-id": "targeted-websites-description"
  }, textProps, {
    children: isAllPages ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "AudienceTargeting.display.targetedWebsites.allPages"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "AudienceTargeting.display.targetedWebsites.somePages"
    })
  }));
};
export default TargetedWebsitesDescription;